import { useEffect } from 'react';

// Injects one or more JSON-LD <script> blocks into <head>. Scripts are tagged
// with data-jsonld={id} so a page can replace its own set without touching the
// global (site-wide) blocks. The platform pre-render captures these in the HTML.
export default function JsonLd({ id = 'page', data }) {
  const json = data
    ? JSON.stringify((Array.isArray(data) ? data : [data]).filter(Boolean))
    : null;

  useEffect(() => {
    const sel = `script[data-jsonld="${id}"]`;
    document.head.querySelectorAll(sel).forEach((e) => e.remove());
    if (!json) return undefined;
    const items = JSON.parse(json);
    const els = items.map((obj) => {
      const el = document.createElement('script');
      el.type = 'application/ld+json';
      el.setAttribute('data-jsonld', id);
      el.text = JSON.stringify(obj);
      document.head.appendChild(el);
      return el;
    });
    return () => els.forEach((e) => e.remove());
  }, [id, json]);

  return null;
}
